import React, { Fragment, Component } from "react";
import { NavLink, Switch, Route } from "react-router-dom";
import styled from "styled-components";

import Header from "../../Components/Header";
import Soundtracks from "./Soundtracks";
import Playlists from "./Playlists";
import Schedules from "./Schedules";
import { API_URL } from '../../Config';
import { handleErrors } from '../../Helpers'

const StyledLink = styled(NavLink)`
  text-decoration: none;
  color: #ccc;
  padding: 0.5rem;
  display: inline-block;
`;

const Tab = ({ title, to, activeStyle, onClick }) => (
  <StyledLink activeStyle={{ color: "inherit" }} onClick={onClick} exact to={to}>
    {title}
  </StyledLink>
);

const Nav = styled.nav`
  padding-bottom: 2rem;

  > div {
    position: fixed;
    top: 4rem;
    background-color: white;
    width: 100%;
    z-index: 1;
    border-bottom: 1px solid #ccc;
  }
  
  ul {
    width: 100%;
    position: relative;
    max-width: 35rem;
    display: flex;
    justify-content: center;
    list-style: none;
    margin: 0 auto;
    padding: 0;

    &:before {
      content: '';
      position: absolute;
      left: 0;
      right: 0;
      bottom: -1px;
      background-image: linear-gradient(90deg, #0019F8, #0019F8 33.3333%, transparent 33.3333%);
      height: 1px;
      transition: transform .25s ease-in-out;
      transform: ${({ activeTab }) => `translateX(${activeTab * 33.3333}%);`}
    }

    li {
      flex: 1;
      text-align: center;
    }
  }
`;

export default class ChangeMusic extends Component {
  constructor(props) {
    super(props);
    this.state = {
      playlists: [],
      schedules: [],
      soundtracks: [],
      menuIndex: window.persistence.local.get('changeMusicPage') || 0
    }
  }

  setMenuIndex = (index) => {
    this.setState({ menuIndex: index });
    window.persistence.local.set('changeMusicPage', index);
  }

  updateData(sourceType) {
    if (this.state[sourceType].length) return
    fetch(`${API_URL}/sources/${sourceType}?token=${this.props.currentZone.token}`)
      .then(handleErrors)
      .then(response => response.json())
      .then(response => {
        let data = {}
        data[sourceType] = response[sourceType]
        this.setState(data);
      })
      .catch(error => console.error("Error", error))
  }

  componentDidMount() {
  }

  render() {
    return (
      <Fragment>
        <Header title="Change Music" donePath="/player" />
        <Nav activeTab={this.state.menuIndex}>
          <div>
            <ul>
              <li><Tab to={`/change-music`} title="Soundtracks" /></li>
              <li><Tab to={`/change-music/playlists`} title="Playlists" /></li>
              <li><Tab to={`/change-music/schedules`} title="Schedules" /></li>
            </ul>
          </div>
        </Nav>
        <div style={{ maxWidth: '35rem', margin: '1rem auto', width: '100%' }}>
          <Switch >
            <Route
              path="/change-music"
              exact
              title="Soundtracks"
              render={(props) =>
                <Soundtracks
                  data={this.state.soundtracks}
                  setMenuIndex={() => this.setMenuIndex(0)}
                  currentPlayFrom={this.props.currentPlayFrom}
                  updateData={()=>this.updateData('soundtracks')}
                  {...props}
                />
              }
            />
            <Route
              path="/change-music/playlists"
              title="Playlists"
              render={(props) => <Playlists data={this.state.playlists} setMenuIndex={() => this.setMenuIndex(1)} {...props} currentPlayFrom={this.props.currentPlayFrom} updateData={()=>this.updateData('playlists')}/>}
            />
            <Route
              path="/change-music/schedules"
              title="Schedules"
              render={(props) => <Schedules data={this.state.schedules} setMenuIndex={() => this.setMenuIndex(2)} {...props} currentPlayFrom={this.props.currentPlayFrom} updateData={()=>this.updateData('schedules')}/>}
            />
          </Switch>
        </div>
      </Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Views/ChangeMusic/ChangeMusic.js